<mat-card class="content-card">


  <mat-card style="width: 250px;">
    <mat-card-header>
      <mat-card-title>Importformat</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>
        Date;Value;Token or Invoice Code<br />
        10.06.2021;48.50;AABD8QS<br />
        13.05.2021;45;433150690<br />
      </p>
    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>

  <br />

    <app-file-upload (upload)="onUpload($event)"></app-file-upload>

  <div *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

    <app-mat-table-generator #table
        tableName="paymentImportsTable"
        [columns]="importsCols"
        [dataSource]="dataSource"
        [multiselectEnabled]="false"
        [viewLink]="getViewLink"
        [useEmbededFilter]="false"
        [rowClassCallback]="getRowClass">
    </app-mat-table-generator>
</mat-card>
